// extracted by mini-css-extract-plugin
export default {"wrapTable":"table_wrapTable__Uf+wA","table":"table_table__oBsx9","item":"table_item__5Ofyl","features":"table_features__n496v"};